<template>
    <el-drawer
            class="dialog-box"
            title="发票详情"
            :visible.sync="showFlag"
            size="80%"

    >
        <div v-loading="detailLoading" class="tabs-demo1">
            <div class="title">
                <div style="display: flex; line-height: 50px; align-items: center">
<!--          <span style="font-size: 18px;color:#409EFF;" >{{-->
<!--            invoiceInfo.invoiceStatusDesc-->
<!--          }}</span>-->
                    <el-tag effect="dark" size="small" v-if="invoiceInfo.invoiceStatus==='TO_INVOICED'" >待开票</el-tag>
                    <el-tag effect="dark" size="small" v-if="invoiceInfo.invoiceStatus==='TO_REVIEWED'">待确认</el-tag>
                    <el-tag effect="dark" size="small" type="success" v-if="invoiceInfo.invoiceStatus==='INVOICED'">已开票</el-tag>
                    <el-tag effect="dark" size="small" type="danger" v-if="invoiceInfo.invoiceStatus==='CANCEL'">已取消</el-tag>
                    <div class="t1">开票主体:{{ invoiceInfo.bodyName }}</div>
                    <div class="t1">
                        申请时间:{{ invoiceInfo.invoiceTime}}
                    </div>
                    <div class="t1">申请编号:{{ invoiceInfo.invoiceNo }}</div>
                </div>
                <div class="operate">
                    <el-button type="text" @click="goLog">操作日志</el-button>
                </div>
            </div>
            <div class="content-top">
                <el-form label-width="120px" label-suffix=":" label-position="left">
                    <el-form-item label="发票类型" v-if="invoiceInfo.invoiceType">{{
                        invoiceInfo.invoiceTypeDesc
                        }}</el-form-item>
                    <el-form-item label="公司名称">{{
                        invoiceInfo.corporateName
                        }}</el-form-item>
                    <el-form-item label="公司税号">{{
                        invoiceInfo.corporateTaxNumber
                        }}</el-form-item>
                    <el-form-item label="订单总额"><span style="color: #409eff">{{ invoiceInfo.orderMoney }}</span>元</el-form-item>
                    <el-form-item label="折扣金额"><span style="color: #409eff">{{ invoiceInfo.discountPrice }}</span>元</el-form-item>
                    <el-form-item label="申请开票金额"><span style="color: #409eff">{{ invoiceInfo.invoiceMoney }}</span>元</el-form-item>

                    <el-form-item
                            label="公司地址"
                            v-if="invoiceInfo.invoiceType != '1'"
                    >{{ invoiceInfo.corporateAddress }}</el-form-item
                    >
                    <el-form-item
                            label="公司开户行"
                            v-if="invoiceInfo.invoiceType != '1'"
                    >{{ invoiceInfo.corporateBank }}</el-form-item
                    >
                    <el-form-item
                            label="开户行账号"
                            v-if="invoiceInfo.invoiceType != '1'"
                    >{{ invoiceInfo.corporateBankNumber }}</el-form-item
                    >
                </el-form>
            </div>
            <!--收件信息-专票-->
<!--            <div v-if="invoiceInfo.invoiceType === '2'">-->
<!--                <p class="tips">收件信息</p>-->
<!--                <div class="content-mid" style="">-->
<!--                    <div id="copy_text">-->
<!--                        {{ invoiceInfo.address }}&nbsp;&nbsp;&nbsp;&nbsp;{{-->
<!--                        invoiceInfo.receiveName-->
<!--                        }}&nbsp;&nbsp;{{ invoiceInfo.phone }}-->
<!--                    </div>-->
<!--&lt;!&ndash;                    <div&ndash;&gt;-->
<!--&lt;!&ndash;                            ref="copy"&ndash;&gt;-->
<!--&lt;!&ndash;                            class="btn1"&ndash;&gt;-->
<!--&lt;!&ndash;                            @click="copy"&ndash;&gt;-->
<!--&lt;!&ndash;                            data-clipboard-action="copy"&ndash;&gt;-->
<!--&lt;!&ndash;                            data-clipboard-target="#copy_text"&ndash;&gt;-->
<!--&lt;!&ndash;                    >&ndash;&gt;-->
<!--&lt;!&ndash;                        复制收件信息&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                </div>-->
<!--            </div>-->
            <!--开票形式-普票-->
            <div>
                <p class="tips">开票形式</p>
                <div class="content-mid" style="">
<!--                    <div id="copy_text">-->
<!--                        {{ invoiceInfo.address }}&nbsp;&nbsp;&nbsp;&nbsp;{{-->
<!--                        invoiceInfo.receiveName-->
<!--                        }}&nbsp;&nbsp;{{ invoiceInfo.phone }}-->
<!--                    </div>-->
                    <el-descriptions :column="2">
                        <el-descriptions-item v-if="invoiceInfo.invoicingType === 'paper'" label="开票形式">{{invoiceInfo.invoicingTypeDesc}}</el-descriptions-item>
                        <el-descriptions-item v-if="invoiceInfo.invoicingType === 'paper'" label="收件信息">{{ invoiceInfo.address }} {{invoiceInfo.receiveName}} {{invoiceInfo.phone}}</el-descriptions-item>
                        <el-descriptions-item v-if="invoiceInfo.invoicingType === 'electronic'" label="开票形式">{{invoiceInfo.invoicingTypeDesc}}</el-descriptions-item>
                        <el-descriptions-item v-if="invoiceInfo.invoicingType === 'electronic'" label="邮箱号">{{invoiceInfo.email}}</el-descriptions-item>
                    </el-descriptions>
<!--                    <div-->
<!--                            ref="copy"-->
<!--                            class="btn1"-->
<!--                            @click="copy"-->
<!--                            data-clipboard-action="copy"-->
<!--                            data-clipboard-target="#copy_text"-->
<!--                    >-->
<!--                        复制收件信息-->
<!--                    </div>-->
                </div>
            </div>

            <p class="tips">发货单列表</p>
            <div class="tablist">
                <el-table
                        :data="invoiceInfo.invoiceOrderList"
                        style="width: 100%"
                        height="200px"
                >
                    <el-table-column prop="date" label="序号" width="60">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="sendNo" label="申请编号" width="160">
                    </el-table-column>
                    <el-table-column prop="orderTime" label="订单日期" width="160">
                        <template slot-scope="scope">
                            {{ scope.row.orderTime}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="商品信息" width="180">
                        <template slot-scope="scope">
                            {{ scope.row.type }}种/{{ scope.row.num }}件
                        </template>
                    </el-table-column>
                    <el-table-column prop="buyerType" label="买家类型"> </el-table-column>
                    <el-table-column
                            prop="orderStatusDesc"
                            label="发货单状态"
                            width="180"
                    >
                    </el-table-column>
                    <el-table-column prop="currency" label="币种">RMB</el-table-column>
                    <el-table-column prop="orderMoney" label="订单金额" width="180">
                    </el-table-column>
                    <el-table-column
                            prop="invoiceMoney"
                            label="预付款账户支付金额"
                            width="180"
                    >
                    </el-table-column>
                    <el-table-column prop="payTime" label="付款时间" width="160">
                        <template slot-scope="scope">
                            {{ scope.row.payTime}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="receiveName" label="收件人" width="180">
                    </el-table-column>
                    <el-table-column prop="buyerRemark" label="买家备注" width="180">
                    </el-table-column>
                    <el-table-column prop="sendWs" label="发货仓" width="100">
                    </el-table-column>
                    <el-table-column prop="sendTime" label="发货时间" width="160">
                        <template slot-scope="scope">
                            {{ scope.row.sendTime}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="receiveAddress" label="收货地址" width="180">
                    </el-table-column>
                    <el-table-column prop="express" label="快递/物流" width="220">
                        <template slot-scope="scope">
                            {{ scope.row.express }}:{{ scope.row.expressNo }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="billSourceDesc" label="订单来源" width="100">
                    </el-table-column>
                    <el-table-column
                            prop="sourceChannelDesc"
                            label="订单渠道"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column prop="paySourceDesc" label="支付方式" width="100">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="goDetail(scope.row)" type="text" size="small"
                            >订单详情</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 客户确认备注-->
            <div>
                <p class="tips">客户确认备注</p>
                <div class="desc-box">
                    <el-input
                            disabled
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="note"
                    >
                    </el-input>
                </div>
            </div>

            <!-- 开票备注-->
            <div>
                <p class="tips">开票备注</p>
                <div class="desc-box">
                    <el-input
                            :disabled="invoiceInfo.invoiceStatus === 'TO_INVOICED'?false:true"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="invoiceInfo.invoiceNote"
                    >
                    </el-input>
                </div>
            </div>

            <div style="text-align: center;margin-top:20px;" class="btn">
<!--                <el-button-->
<!--                        type="primary"-->
<!--                        @click="submit"-->
<!--                        v-if="invoiceInfo.invoiceStatus == 'INVOICED'"-->
<!--                >提交</el-button-->
<!--                >-->
<!--                <el-button-->
<!--                        type="primary"-->
<!--                        @click="approveSucc"-->
<!--                        v-if="invoiceInfo.invoiceStatus == 'TO_REVIEWED'"-->
<!--                >同意</el-button-->
<!--                >-->
                <!--待确认- 取消-->
                <el-button
                        type="danger"
                        @click="approveFail"
                        v-if="invoiceInfo.invoiceStatus == 'TO_REVIEWED'"
                >取消</el-button
                >
                <!--待开票 - 开票-->
                <el-button
                        type="primary"
                        @click="invoicingSure"
                        v-if="invoiceInfo.invoiceStatus == 'TO_INVOICED'"
                >开票</el-button>
<!--                <el-button type="primary"-->
<!--                           @click="invoicingSure">保存</el-button>-->
                <el-button type="primary" @click="downloadTemplate">下载发票模板</el-button>
                <el-button type="primary" @click="back">返回</el-button>
            </div>
        </div>
        <!-- 发货单 -->
        <invoice-detail ref="invoiceDetail"></invoice-detail>
        <logs ref="logs"></logs>
    </el-drawer>
</template>

<script>
    import logs from "./operateLog";
    import { OrderApi } from "@/modules/server-api/commodity-sys/order";
    import { invoiceApi } from "@/modules/server-api/invoice";
    import Clipboard from "clipboard";
    import invoiceDetail from '@/modules/order/orderDetail/invoiceDetail';
    import { downloadFileTemplate, downloadExcel } from "@/utils/downloadExcel.js";
    export default {
        props: {},
        components: {
            logs,invoiceDetail
        },
        data() {
            return {
                note: "", //审核备注
                invoiceNote: "", //开票备注
                showFlag: false,
                loaded: false,
                tableData: [],
                invoiceNo: "",
                invoiceInfo: {},
                textarea: "",
                operationId: "",
                operationName: "",
                detailLoading:false,
            };
        },
        activated() {
            console.log("===================");
            // let userInfo = JSON.parse(localStorage.getItem("user_state"));
            // this.operationId = userInfo.userId;
            // this.operationName = userInfo.name;
            // this.invoiceNo = this.$route.query.invoiceNo;
            // this.queryDetail();
        },
        computed: {},
        methods: {
            //发票文件模板下载
            downloadTemplate(){
                // let params = {
                //     invoiceNo:'222'
                // }
                let params = new FormData();
                params.append('invoiceNo',this.invoiceInfo.invoiceNo);
                downloadExcel('/data-dist/api/dist/invoice/info/export',params, '发票模板.xlsx');
            },
            back() {
                this.showFlag = false;
            },
            getData(row) {
                console.log(row);
                this.showFlag = true;
                let userInfo = JSON.parse(localStorage.getItem("user_state"));
                this.operationId = userInfo.userId;
                this.operationName = userInfo.name;
                this.invoiceNo = row.invoiveNo;
                this.queryDetail(row);
            },
            submit() {
                if (
                    this.invoiceNote == "" ||
                    this.invoiceNote.split(" ").join("").length == 0
                ) {
                    this.$notifyError("请填写提交提交备注");
                } else {
                    let params = {
                        invoiceNote: this.invoiceNote,
                        operationId: this.operationId,
                        operationName: this.operationName,
                        invoiceNo: this.invoiceNo,
                    };
                    invoiceApi.saveDesc(params).then((res) => {
                        if (res.succ == 1) {
                            this.$notifySuccess("提交成功");
                        } else {
                            this.$notifyError("提交失败");
                        }
                        this.showFlag=false;
                    });
                }
            },
            async goDetail(row) {
                let res = await OrderApi.getOrderGoods({
                    orderNo: row.sendNo,
                    goodLoc: 1,
                });
                console.log(res.result, "订单详情");
                sessionStorage.setItem("detail", JSON.stringify(res.result));
                sessionStorage.setItem("editFlag", false);
                this.$refs.invoiceDetail.getData()
                // this.$router.push({ path: "/modules/order/orderDetail" }).catch(() => {});
            },
            goBack() {
                this.$router.push("/modules/invoice/list");
            },
            queryDetail(row) {
                let params = { invoiceNo: row.invoiceNo };
                invoiceApi.detailInvoice(params).then((res) => {
                    if (res.succ == 1) {
                        // console.log(res.result, "=======");
                        this.invoiceInfo = row;
                        console.log(this.invoiceInfo);
                        this.invoiceInfo.invoiceOrderList = res.result;
                        this.note = this.invoiceInfo.note;
                        this.invoiceNote=this.invoiceInfo.invoiceNote;
                    } else {
                        this.$notifyError(res.error);
                    }
                }).finally(e=>{
                    this.detailLoading = false;
                });
            },
            goLog() {
                this.$refs.logs.getData(this.invoiceInfo.invoiceNo);
                // this.$router.push({
                //   path: "/modules/invoice/operateLog",
                //   query: {
                //     invoiceNo: this.invoiceNo,
                //   },
                // });
            },
            search(selectTJ) {
                console.log(selectTJ, "筛选条件");
                this.$refs.listTable.getList(selectTJ);
            },
            copy() {
                let clipboard = new Clipboard(".btn1");
                clipboard.on("success", (e) => {
                    this.$notifySuccess("复制成功!");
                    clipboard.destroy();
                });
                clipboard.on("error", (e) => {
                    // 不支持复制
                    this.$notifyError("复制失败");
                    clipboard.destroy();
                });
            },

            //审核成功
            approveSucc(tr) {
                let params = {
                    type: "ONLY",
                    invoiceNo: this.rowData.invoiceNo,
                    operation: "REVIEWED",
                    operationId: this.operationId,
                    operationName: this.operationName,
                    note: this.note,
                };
                invoiceApi.approve(params).then((res) => {
                    if (res.succ) {
                        this.$message({
                            type: "success",
                            message: "操作成功！",
                        });
                        this.$emit("refresh");
                    } else {
                        this.$message({
                            type: "error",
                            message: res.error,
                        });
                    }
                    this.showFlag = false;
                });
            },
            //取消
            approveFail(tr) {
                console.log(tr);

                this.$confirm("请确认是否取消？",'提示',{
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(()=>{
                    let params = {
                        invoiceNos: this.invoiceInfo.invoiceNo,
                        operation: "CANCEL",
                        operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                        operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                    };
                    invoiceApi.approve(params).then((res) => {
                        if (res.succ === 1) {
                            this.$message({
                                type: "success",
                                message: "操作成功！",
                            });
                            this.$emit("refresh");
                        } else {
                            this.$message({
                                type: "error",
                                message: res.error,
                            });
                        }
                        this.showFlag = false;
                    });
                }).catch(()=>{

                })

            },
            //开票
            invoicingSure() {
                this.$confirm("请确认是否开票？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        let params = {
                            invoiceNos: this.invoiceInfo.invoiceNo,
                            operation: "INVOICED",
                            invoiceNote:this.invoiceInfo.invoiceNote,
                            operationId:JSON.parse(sessionStorage.getItem('user_state')).userId,
                            operationName:JSON.parse(sessionStorage.getItem('user_state')).name,
                        };
                        invoiceApi.approve(params).then((res) => {
                            if (res.succ) {
                                this.$message({
                                    type: "success",
                                    message: "操作成功！",
                                });
                                this.$emit('refresh')
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.error,
                                });
                            }
                            this.showFlag = false;
                        });
                    })
                    .catch(() => {});
            },
        },
    };
</script>
<style lang="scss" scoped>
    .content-mid /deep/.el-descriptions__body{
        padding: 10px!important;
    }
    .t1 {
        margin-left: 20px;
    }

    .btn1 {
        background: #fff;
        border: solid 1px black;
        padding: 3px;
        border-radius: 4px;
    }

    .tabs-demo1 {
        width: 100%;
        /* background: #f5f5f5; */
        padding: 0px 20px 20px;
    }

    .title {
        width: 100%;
        display: flex;
        position: relative;

        .operate {
            position: absolute;
            right: 0px;
        }
    }

    .content-top {
        background: #f5f5f5;
        padding: 20px 10px;
        box-sizing: border-box;

        .el-form /deep/.el-form-item {
            margin-bottom: 0px;
        }
    }

    .tips {
        line-height: 30px;
        font-size: 16px;
        color: #c7c7c7;
        margin: 10px 0px;
    }

    .content-mid {
        padding: 10px;
        background: #f5f5f5;
        display: flex;
        justify-content: space-between;
    }

    .desc-box {
        padding: 20px;
        background: #f5f5f5;
        border-radius: 4px;
        margin: 20px 0px;
    }

    .btn .el-button {
        /*width: 100px;*/
    }
    .dialog-box {
    }
    .dialog-box /deep/.el-drawer__header {
        margin-bottom: 10px !important;
        span {
            font-size: 16px;
            font-weight: 600;
        }
    }
</style>
